export default "__VITE_ASSET__CXbyvNUI__"